export default "__VITE_ASSET__DdltLmkv__"